import React from 'react';

export default function CareGuide() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-12">
      <div className="max-w-4xl mx-auto px-4 space-y-8 bg-white p-8 md:p-12 rounded-2xl border border-[#E8DFD8] shadow-sm">
        <div className="text-center space-y-2 border-b border-[#E8DFD8] pb-6">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45]">Sacred Maintenance</span>
          <h1 className="font-heading text-3xl font-bold text-[#2B1810]">Sandalwood Care Guide</h1>
          <p className="text-xs text-[#8A796C]">Preserving natural fragrance, luster, and spiritual sanctity</p>
        </div>

        <div className="space-y-6 text-xs leading-relaxed text-[#2B1810]">
          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">1. Keeping Away From Excess Water</h2>
            <p className="text-[#8A796C]">
              Natural sandalwood wood fibers absorb water. Avoid washing your sandalwood Ganesha idols, malas, or keychains directly under running tap water or soaking them in liquids. Gently wipe with a dry soft cotton microfiber cloth.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">2. Reviving Natural Aroma</h2>
            <p className="text-[#8A796C]">
              Over time, natural dust can cover the pores of sandalwood. To release the warm core fragrance:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-[#8A796C]">
              <li>Gently rub the wooden beads between your palms for 30 seconds to warm the natural oils.</li>
              <li>Store your mala or idol inside an airtight cotton pouch or velvet-lined box when not in use.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">3. Avoid Synthetic Chemicals</h2>
            <p className="text-[#8A796C]">
              Do not apply synthetic perfumes, chemical polishes, or harsh alcohol sprays on your pure sandalwood items.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
